import { Typography } from './Typography';
import { Check } from 'lucide-react';
import styles from './CaseCard.module.css';
type Case = {
  tag: string;
  name: string;
  sub: string;
  bullets: string[];
  big: string;
  bigLbl: string;
};
export function CaseCard({ project }: { project: Case }) {
  return (
    <article className={styles.card}>
      <Typography variant="eyebrow" tone="muted">
        {project.tag}
      </Typography>
      <Typography as="h3" variant="quote">
        {project.name}
      </Typography>
      <Typography tone="muted">{project.sub}</Typography>
      <ul className={styles.list}>
        {project.bullets.map((x) => (
          <li key={x}>
            <Check size={16} aria-hidden />
            <Typography variant="small">{x}</Typography>
          </li>
        ))}
      </ul>
      <div className={styles.metric}>
        <Typography as="span" variant="metric">
          {project.big}
        </Typography>
        <Typography variant="metricLabel" tone="muted">
          {project.bigLbl}
        </Typography>
      </div>
    </article>
  );
}
